import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { GameManager } from "../../GameManager";

export class LevelCompletedContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        let tmpBackground = new Phaser.GameObjects.Graphics(this.scene);
        tmpBackground.fillStyle(0x000000, .001);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        tmpBackground.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        tmpBackground.on("pointerdown", () => {
            // 
        }, this);
        this.add(tmpBackground);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        let title = new Phaser.GameObjects.Image(this.scene, 0, -200, "texture_atlas_1", "txt_cleared");
        scaledItemsContainer.add(title);

        let bck = new Phaser.GameObjects.Image(this.scene, 0, 100, "texture_atlas_1", "layout_result");
        scaledItemsContainer.add(bck);

        const replayButton = new Button(this.scene, -150, 145, "texture_atlas_1", "btn_reset", "btn_reset_hover");
        replayButton.onUp(this.onClickReplay, this);
        scaledItemsContainer.add(replayButton);

        const replayText = new Phaser.GameObjects.Text(this.scene, -90, 145, "Replay level", {fontFamily: "Arista", fontSize: "55px", color: "#09808D"});
        replayText.setOrigin(0, .5);
        scaledItemsContainer.add(replayText);

        if (GameVars.difficulty === GameConstants.DIFFICULTY_HERO && GameVars.currentLevel === GameConstants.TOTAL_HERO_LEVELS) {
            const levelsButton = new Button(this.scene, -150, 35, "texture_atlas_1", "btn_lvls", "btn_lvls_hover");
            levelsButton.onUp(this.onClickLevelsScene, this);
            scaledItemsContainer.add(levelsButton);

            const nextLevelText = new Phaser.GameObjects.Text(this.scene, -90, 35, "Levels", {fontFamily: "Arista", fontSize: "55px", color: "#09808D"});
            nextLevelText.setOrigin(0, .5);
            scaledItemsContainer.add(nextLevelText);
        } else {
            const nextLevelButton = new Button(this.scene, -150, 35, "texture_atlas_1", "btn_next", "btn_next_hover");
            nextLevelButton.onUp(this.onClickLevels, this);
            scaledItemsContainer.add(nextLevelButton);

            const nextLevelText = new Phaser.GameObjects.Text(this.scene, -90, 35, "Next level", {fontFamily: "Arista", fontSize: "55px", color: "#09808D"});
            nextLevelText.setOrigin(0, .5);
            scaledItemsContainer.add(nextLevelText);
        }

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
            delay: 250
        });
    }

    private onClickLevels(): void {
        
        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
            GameVars.typeAd = "NextLevel";
        } else {
            GameManager.goToNextLevel();
        }
    }

    private onClickReplay(): void {

        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
            GameVars.typeAd = "BoardScene";
            GameVars.levelAd = GameVars.currentLevel;
        } else {
            this.scene.cameras.main.fadeOut(300, 255, 255, 255);

            this.scene.cameras.main.once("camerafadeoutcomplete", function (): void {
                GameManager.enterBoardScene();
            }, this); 
        }
    }

    private onClickLevelsScene(): void {

        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
            GameVars.typeAd = "DifficultyScene";
        } else {
            this.scene.cameras.main.fadeOut(300, 255, 255, 255);

            this.scene.cameras.main.once("camerafadeoutcomplete", function (): void {
                GameManager.enterDifficultySelectionScene();
            }, this); 
        }
    }
}
